/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelanceCompanyPersonResource
 */
export interface FreelanceCompanyPersonResource {
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    lastName?: string;
    /**
     * 
     * @type {Date}
     * @memberof FreelanceCompanyPersonResource
     */
    birthDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    nationalityCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    birthCity?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    birthCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonResource
     */
    pictureUrl?: string;
}

/**
 * Check if a given object implements the FreelanceCompanyPersonResource interface.
 */
export function instanceOfFreelanceCompanyPersonResource(value: object): value is FreelanceCompanyPersonResource {
    return true;
}

export function FreelanceCompanyPersonResourceFromJSON(json: any): FreelanceCompanyPersonResource {
    return FreelanceCompanyPersonResourceFromJSONTyped(json, false);
}

export function FreelanceCompanyPersonResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelanceCompanyPersonResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
        'nationalityCountryCode': json['nationalityCountryCode'] == null ? undefined : json['nationalityCountryCode'],
        'birthCity': json['birthCity'] == null ? undefined : json['birthCity'],
        'birthCountryCode': json['birthCountryCode'] == null ? undefined : json['birthCountryCode'],
        'pictureUrl': json['pictureUrl'] == null ? undefined : json['pictureUrl'],
    };
}

export function FreelanceCompanyPersonResourceToJSON(value?: FreelanceCompanyPersonResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate']).toISOString().substring(0,10)),
        'nationalityCountryCode': value['nationalityCountryCode'],
        'birthCity': value['birthCity'],
        'birthCountryCode': value['birthCountryCode'],
        'pictureUrl': value['pictureUrl'],
    };
}

